module.exports = __webpack_public_path__ + "staticcomp/img/content_3.b639823.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/10/content_3.jpg
// module id = +y1C
// module chunks = 39